'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.performConnect = undefined;

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _waitForConnection = require('./waitForConnection');

var _connectionStates = require('../constants/connectionStates');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noop = function noop() {};

var performConnect = exports.performConnect = function performConnect(connection, _ref) {
  var _ref$onDisconnect = _ref.onDisconnect,
      onDisconnect = _ref$onDisconnect === undefined ? noop : _ref$onDisconnect,
      _ref$onReconnect = _ref.onReconnect,
      onReconnect = _ref$onReconnect === undefined ? noop : _ref$onReconnect,
      _ref$onFailure = _ref.onFailure,
      onFailure = _ref$onFailure === undefined ? noop : _ref$onFailure,
      _ref$onConnect = _ref.onConnect,
      onConnect = _ref$onConnect === undefined ? noop : _ref$onConnect;

  var promise = new _q2.default.Promise(function (resolve, reject) {
    (0, _waitForConnection.waitForConnection)(connection).then(onConnect).then(resolve, reject).done();

    connection.connect();
  });

  return promise.then(function () {
    connection.off();

    connection.on(_connectionStates.CONNECTED, onReconnect);
    connection.on(_connectionStates.DISCONNECTED, onDisconnect);
    connection.on(_connectionStates.FAILED, onFailure);
  });
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-pub-sub/static-1.4265/js/ably/api-wrappers/performConnect.js
// module id = 403
// module chunks = 2 3